import { render, staticRenderFns } from "./Dashboard_CM.vue?vue&type=template&id=72fdb9c7&scoped=true&"
import script from "./Dashboard_CM.vue?vue&type=script&lang=js&"
export * from "./Dashboard_CM.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_CM.vue?vue&type=style&index=0&id=72fdb9c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdb9c7",
  null
  
)

export default component.exports